<template>
  <div class="search-container">
    <!-- 搜索的一部电影 -->
    <div class="search-result" v-for="item in movieList" :key="item.movieId">
      <!-- 电影海报 -->
      <div class="img-container">
        <router-link :to="'/movieInfo/' + item.movieId">
          <img :src="item.moviePoster">
        </router-link>
      </div>
      <!-- 电影信息 -->
      <div class="movie-info">
        <div class="movie-name">{{item.movieName}}</div>
        <div class="movie-category">{{item.movieCategoryList.join('/')}}</div>
        <div class="movie-releaseDate">{{item.releaseDate}}上映</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchMovie",
  props:{
    keyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return{
      movieList: [
        {
          movieCategoryList: [],
          movieId: 0,
          movieLength: 0,
          movieName: '',
          moviePoster: '',
          releaseDate: ''
        }
      ]
    }
  },
  created() {
    this.getSearchMovieList()
  },
  methods:{
    async getSearchMovieList(){
      let queryInfo = {
        movieName: this.keyword
      }
      const { data : res } = await axios.get('sysMovie/find', {params : queryInfo})
      if(res.code !== 200) return this.$message.error('获取信息失败')
      this.movieList = res.data
      for(let movie of this.movieList){
        movie.moviePoster = this.global.base + JSON.parse(movie.moviePoster)[0]
        movie.movieCategoryList = movie.movieCategoryList.map((obj, index) => {
          return obj.movieCategoryName
        })
      }
    }
  },
  watch:{
    '$route'(){
      this.getSearchMovieList()
    }
  }
}
</script>

<style scoped>
.search-container{
  width: 980px;
  margin: 0px auto;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.search-result{
  width: 460px;
  margin: 30px 0 0 30px;
  display: flex;
  min-width: 0;
}

.img-container{
  width: 160px;
  height: 220px;
  margin-right: 20px;
}

.img-container img{
  width: 100%;
  height: 100%;
}

a{
  text-decoration: none;
  cursor:pointer;
}

.movie-info{
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 5px;
  font-size: 16px;
  width: 280px;
  border-bottom: solid #eee 1px;
  min-width: 0;
}

.movie-name{
  font-size: 26px;
  margin-top: 27px;
  line-height: 1.3;
}

.movie-ename{
  font-size: 14px;
  color: #999;
  margin-top: 3px;
}

.movie-score{
  font-size: 26px;
  margin-bottom: 13px;
  color: #ffb400;
  height: 31px;
  line-height: 31px;
}

.movie-category{
  color: #333;
}

.movie-releaseDate{
  color: #999;
}

.movie-name,
.movie-category,
.movie-releaseDate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .search-container{
    width: 100%;
    padding: 0 16px 20px;
    margin-bottom: 0;
  }

  .search-result{
    width: 100%;
    margin: 16px 0 0;
    padding: 14px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    align-items: flex-start;
  }

  .img-container{
    width: 96px;
    height: 132px;
    margin-right: 14px;
    flex-shrink: 0;
  }

  .movie-info{
    width: auto;
    flex: 1;
    margin-top: 0;
    border-bottom: 0;
    gap: 10px;
  }

  .movie-name{
    margin-top: 0;
    font-size: 20px;
    white-space: normal;
  }

  .movie-category,
  .movie-releaseDate{
    white-space: normal;
    line-height: 1.5;
  }
}
</style>
